export default class AnalysisMatch {
    time = null;
    league = null;
    homeId = null;
    homeName = 0;
    homeScore = 0;
    homeHalfScore = null;
    awayId = null;
    awayName = null;
    awayScore = null;
    awayHalfScore = null;
    asia = null;
    asiaString = 0;
    asiaResult = -100;
    daxiao = 0;
    daxiaoString = 0;
    daxiaoResult = -100;
    data = null;
    isHome = false;

    constructor(data) {
        if (data) {
            this.data = data;
            this.time = data[3];
            this.league = data[1];
            this.homeId = data[5][0];
            this.awayId = data[6][0];
            this.asia = this.getAsia();
            this.daxiao = this.getDaxiao();
            this.homeScore = this.getMatchScore(5, 2);
            this.homeHalfScore = this.getMatchScore(5, 3);
            this.awayScore = this.getMatchScore(6, 2);
            this.awayHalfScore = this.getMatchScore(6, 3);
        }
    }

    initHome(isHome) {
        this.isHome = isHome;
        this.asiaResult = this.getAsiaResult();
        this.asiaString = this.getAsiaString();
        this.daxiaoResult = this.getDaxiaoResult();
        this.daxiaoString = this.getDaxiaoString();
    }

    getAsiaResult() {
        if (this.asiaResult == -100) {
            let asiz = this.homeScore - this.awayScore - this.asia;
            if (this.isHome) {
                this.asiaResult = asiz > 0 ? 1 : (asiz == 0 ? 0 : -1);
            } else {
                this.asiaResult = asiz > 0 ? -1 : (asiz == 0 ? 0 : 1);
            }
        }
        return this.asiaResult;
    }


    getAsiaString() {
        if (this.asia % 0.5 == 0) {
            this.asiaString = this.asia.toFixed(2);
        } else {
            let num: number = this.asia - 0.25;
            let n2: any = num.toFixed(2);
            this.asiaString = Math.abs(n2 / (this.asia + 0.25).toFixed(2));
        }
        return this.asiaString;
    }

    getDaxiaoResult() {
        if (this.daxiaoResult == -100) {
            this.daxiaoResult = this.homeScore + this.awayScore - this.daxiao;
        }
        return this.daxiaoResult;
    }

    getDaxiaoString() {
        if (!this.daxiaoString) {
            if (this.daxiao % 0.5 == 0) {
                this.asiaString = parseInt(this.daxiao.toFixed(2));
            } else {
                let num: any = ((this.daxiao - 0.25) / (this.daxiao + 0.25)).toFixed(2)
                this.asiaString = num
            }
        }
        return this.asiaString;
    }

    getAsia() {
        if (this.data) {
            let asia = this.data[7][0].split(',');
            if (asia && asia.length > 1) {
                let nasiz = Number(asia[1]);
                return isNaN(nasiz) ? 0 : nasiz;
            }
        }
        return 0;
    }

    getDaxiao() {
        if (this.data) {
            let dx = this.data[7][2].split(',');
            if (dx && dx.length > 1) {
                let nasiz = Number(dx[1]);
                return isNaN(nasiz) ? 0 : nasiz;
            }
        }
        return 0;
    }


    getMatchScore(idx, index1) {
        if (this.data) {
            if (this.data[idx]) {
                return this.data[idx][index1];
            }
        }
        return 0;
    }

}
